import { type AppointmentChainConfiguration } from '@/schemas/admin/appointment-chain-configurations.schema.ts';

import {
    type MainPractitionerOption,
    hasActiveMarkedSteps as computeHasActiveMarkedSteps,
    getEligibleMainPractitioners,
    getMainPractitionerCalendarIds,
} from '@/utils/chain-main-practitioner-utils.ts';

interface UseChainMainPractitionerOptionsParams {
    config: AppointmentChainConfiguration | undefined;
    removedOrders: number[];
}

interface UseChainMainPractitionerOptionsResult {
    options: MainPractitionerOption[];
    hasActiveMarkedSteps: boolean;
    isEligibleSelection: (practitionerId: string | undefined) => boolean;
    mainPractitionerCalendarIdsFor: (order: number, practitionerId: string) => Set<string>;
}

export const useChainMainPractitionerOptions = ({
    config,
    removedOrders,
}: UseChainMainPractitionerOptionsParams): UseChainMainPractitionerOptionsResult => {
    const options = config ? getEligibleMainPractitioners(config, removedOrders) : [];
    const hasActiveMarkedSteps = config ? computeHasActiveMarkedSteps(config, removedOrders) : false;

    const isEligibleSelection = (practitionerId: string | undefined): boolean =>
        !!practitionerId && options.some((option) => option.practitioner_id === practitionerId);

    const mainPractitionerCalendarIdsFor = (order: number, practitionerId: string): Set<string> =>
        config ? getMainPractitionerCalendarIds(config, order, practitionerId) : new Set<string>();

    return {
        options,
        hasActiveMarkedSteps,
        isEligibleSelection,
        mainPractitionerCalendarIdsFor,
    };
};
